import { render, staticRenderFns } from "./BottomLoading.vue?vue&type=template&id=50abd747&scoped=true"
import script from "./BottomLoading.vue?vue&type=script&lang=js"
export * from "./BottomLoading.vue?vue&type=script&lang=js"
import style0 from "./BottomLoading.vue?vue&type=style&index=0&id=50abd747&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50abd747",
  null
  
)

export default component.exports